<template>
    <Popper
        v-bind="$props"
        :class-name="[className, 'z-30']"
        :trigger="event"
        ref="popper"
        v-on="$listeners"
    >
        <template #trigger>
            <slot name="trigger" />
        </template>
        <slot />
    </Popper>
</template>

<script>
    import Popper from '../Popper/Popper.vue';

    /**
     * Popover is a structural component used for showing and positioning pop-ups and tooltips over a given element.
     * @displayName Popover
     */
    export default {
        name: 'ActivixPopover',

        components: {
            Popper,
        },

        props: {
            triggerTarget: {
                type: null,
                default: null,
            },
            event: {
                type: String,
                default: 'click',
                validator: (value) => ['click', 'hover', 'manual'].includes(value),
            },
            sameWidth: {
                type: Boolean,
                default: false,
            },
            strategy: {
                type: String,
                default: 'fixed',
                validator: (value) => ['absolute', 'fixed'].includes(value),
            },
            placement: {
                type: String,
                default: 'top',
                validator: (value) => [
                    'auto', 'auto-start', 'auto-end',
                    'top', 'top-start', 'top-end',
                    'bottom', 'bottom-start', 'bottom-end',
                    'right', 'right-start', 'right-end',
                    'left', 'left-start', 'left-end',
                ].includes(value),
            },
            className: {
                type: String,
                default: 'bg-white rounded-md shadow-lg border border-gray-200',
            },
            closeDelay: {
                type: Number,
                default: 100,
            },
            offset: {
                type: Number,
                default: 4,
            },
        },

        methods: {
            toggle() {
                this.$refs.popper.toggle();
            },

            open() {
                this.$refs.popper.open();
            },

            close() {
                this.$refs.popper.close();
            },
        },
    };
</script>
